import React, { useEffect, useState } from 'react';

function SideMenu({ isSidebarOpen, toggleSidebar }) {
    useEffect(() => {
        // Handle sidebar visibility based on `isSidebarOpen`
        if (isSidebarOpen) {
            document.getElementById('side-bar').classList.add('show');
            document.getElementById('anywhere-home').classList.add('bgshow');
        } else {
            document.getElementById('side-bar').classList.remove('show');
            document.getElementById('anywhere-home').classList.remove('bgshow');
        }
    }, [isSidebarOpen]);

    useEffect(() => {
        // Event handler for menu links
        const handleMenuClick = (event) => {
            if (event.target.matches('.mainmenu li a')) {
                toggleSidebar(); // Close the sidebar
            }
        };

        // Attach click event listener
        document.addEventListener('click', handleMenuClick);

        // Cleanup the event listener on unmount
        return () => {
            document.removeEventListener('click', handleMenuClick);
        };
    }, [toggleSidebar]);

    return (
        <>
            <div id="side-bar" className={`side-bar header-two ${isSidebarOpen ? 'show' : ''}`}>
                <div className="close-icon-menu with-after2" aria-label="Close Menu" onClick={toggleSidebar}>
                    <span>
                        <img src="assets/images/icon/close.png" alt="Close Menu" />
                    </span>
                </div>
                {/* Mobile menu area start */}
                <div className="mobile-menu-main onepage">
                    <nav className="nav-main mainmenu-nav mt--30">
                        <ul className="mainmenu metismenu" id="mobile-menu-active">
                            <li className="main-nav">
                                <a className="main-menu" href="#home">
                                    Home
                                </a>
                            </li>
                            <li className="main-nav">
                                <a className="main-menu" href="#about">
                                    About Us
                                </a>
                            </li>
                            <li className="main-nav">
                                <a className="main-menu" href="#tokenomics">
                                    Tokenomics
                                </a>
                            </li>
                            <li className="main-nav">
                                <a className="main-menu" href="#roadmap">
                                    Roadmap
                                </a>
                            </li>
                            <li className="main-nav">
                                <a className="main-menu" href="#faq">
                                    FAQ
                                </a>
                            </li>
                            <li className="main-nav">
                                <a className="main-menu" href="#contact">
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                {/* Mobile menu area end */}
                <div className="social-area">
                    <div className="social-wrapper">
                        <a href="#">
                            <img src="assets/images/icon/01.svg" aria-label="discord" alt="Discord" />
                        </a>
                    </div>
                    <div className="social-wrapper">
                        <a href="#">
                            <img src="assets/images/icon/02.svg" aria-label="telegram" alt="Telegram" />
                        </a>
                    </div>
                    <div className="social-wrapper">
                        <a href="#">
                            <img src="assets/images/icon/03.svg" aria-label="X" alt="X" />
                        </a>
                    </div>
                    <div className="social-wrapper">
                        <a href="#">
                            <img src="assets/images/icon/04.svg" aria-label="instagram" alt="Instagram" />
                        </a>
                    </div>
                </div>
            </div>
            <div id="anywhere-home" onClick={toggleSidebar}></div>
        </>
    );
}

export default SideMenu;
